import React, { useEffect, useState } from 'react';
import cx from 'classnames';

import Multistep from '@magoosh/lib/multistep';
import { paths } from 'config/path_helpers';
import trackEvent from 'utilities/track_event';

import RegistrationForm from '@payments/organisms/forms/registration';
import UserForm from '@payments/organisms/forms/user';
import { SubscriptionFormProps } from '@payments/types';

import graduatePhoto from './assets/smiling_graduate.jpg';
import style from '@payments/style.module.scss';

const Register: React.FC<SubscriptionFormProps> = (props) => {
  const abTest = props.abTest || {};

  useEffect(() => {
    trackEvent(`Checkout > Register > View`, { ...abTest });
  }, []);

  const Registration = props.twoStepSignup ? TwoStepRegistration : SingleStepRegistration;

  return (
    <div className="u-margin-T-l">
      <Registration {...props} />
    </div>
  );
};

const SingleStepRegistration: React.FC<SubscriptionFormProps> = (props) => {
  return (
    <RegistrationForm {...props} />
  );
};

const TwoStepRegistration: React.FC<SubscriptionFormProps> = (props) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [userRegistrationFormData, setUserRegistrationFormData] = useState(null);

  const handleAccountStepComplete = (values: any) => {
    setUserRegistrationFormData(values);
    moveToStep(2);
  };

  const moveToStep = (step: number) => {
    // TODO - existing behavior is to clear out the form. Should it?
    if (step === 1) {
      setUserRegistrationFormData(null);
    }

    setCurrentStep(step);
  };

  return (
    <Multistep currentStep={currentStep}>
      <Multistep.StepIndicators navigate={moveToStep} />

      <Multistep.Step name="Account" navigable>
        <div className="d-flex u-margin-T-m">
          <div style={{flex: 1.5}}>
            {
              props.signupMotivators ? (
                <div>
                  <h3 className="text-primary u-margin-T-n">Create an account and get one step closer to your acceptance letter</h3>
                  <p>You're protected by our 7-day no questions asked money-back guarantee.</p>
                </div>
              ) : (
                <h2 className="text-primary u-margin-V-n">Create an Account</h2>
              )
            }

            <div className="help-block">
              If you already have a Magoosh account,{' '}
              <a href={paths.login(true)}>sign in here</a>
            </div>

            <UserForm
              abTest={props.abTest}
              isEuUser={props.isEuUser}
              onComplete={handleAccountStepComplete}
            />
          </div>

          {
            props.signupMotivators && (
              <div className={cx(style.heroPhoto, 'hidden-sm hidden-xs')}>
                <img src={graduatePhoto} alt="Smiling graduate" />
              </div>
            )
          }
        </div>
      </Multistep.Step>

      <Multistep.Step name="Payment">
        <div className="u-margin-T-m">
          <RegistrationForm {...props} user={userRegistrationFormData} />
        </div>
      </Multistep.Step>
    </Multistep>
  )
};

export default Register;


